var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valor)?_c('div',{attrs:{"title":"Remover Parametro de Busca"},on:{"click":_vm.onClick}},[(_vm.label !== 'Tipo')?_c('strong',[_vm._v(_vm._s(_vm.label)+":")]):_c('strong',[_vm._v(_vm._s(_vm.valor.includes(",") ? "Tipos:" : "Tipo:"))]),_c('span',[_vm._v(_vm._s(_vm.truncate(_vm.valor, { length: 50 })))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }